import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const rootElement = document.getElementById("root");
const root = ReactDOM.createRoot(rootElement);

// Compatible avec react-snap pour le pré-rendu SSG
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
